import { PageShell, PageHero } from '@/components/site/PageShell';
import { DocBody } from '@/components/site/DocBody';
import { Seo } from '@/components/seo/Seo';
import { SITE } from '@/content/site';

const Toc = ({ sections }) => (
  <nav aria-label="On this page" className="hidden lg:block sticky top-28 self-start" data-testid="doc-toc">
    <p className="font-mono text-xs uppercase tracking-widest text-[#71717A] mb-4">On this page</p>
    <ul className="space-y-2 border-l border-[#E4E4E7]">
      {sections.map((s) => (
        <li key={s.id}>
          <a href={`#${s.id}`} className="block pl-4 -ml-px border-l border-transparent text-sm text-[#71717A] hover:text-[#0047FF] hover:border-[#0047FF] transition-colors">
            {s.heading}
          </a>
        </li>
      ))}
    </ul>
  </nav>
);

// Generic renderer for long-form policy documents (privacy, terms, cookies, guidelines).
export default function DocPage({ doc, testId }) {
  return (
    <PageShell testId={testId}>
      <Seo title={doc.title} description={doc.description} />
      <PageHero eyebrow={`Last updated ${SITE.legalUpdated}`} title={doc.title}>
        <p>{doc.intro}</p>
      </PageHero>
      <div className="max-w-6xl mx-auto px-6 py-16 grid gap-16 lg:grid-cols-[240px_1fr]">
        <Toc sections={doc.sections} />
        <article className="max-w-3xl">
          {doc.sections.map((s) => (
            <section key={s.id} id={s.id} className="scroll-mt-28 mb-12" data-testid={`doc-section-${s.id}`}>
              <h2 className="font-heading text-xl md:text-2xl font-bold tracking-tight text-[#09090B] mb-4">{s.heading}</h2>
              <DocBody body={s.body} />
            </section>
          ))}
        </article>
      </div>
    </PageShell>
  );
}
